export default __webpack_public_path__ + "static/char-s-15-kr-dff6ac526352cb8568439a63bb566d7a.webp";